import { QueryClient } from '@tanstack/react-query';
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
            staleTime: 0, // do not cache
        },
    },
});
// For debugging with dev tools: https://tanstack.com/query/v5/docs/framework/react/devtools
window.__TANSTACK_QUERY_CLIENT__ = queryClient;
